<template>
	<div class="container-fluid px-lg-2 px-xl-4" >
		<!-- <div class="row" ref="ancla">
			<div class="col-12 p-1">
				<img alt="image slot" src="@/assets/img-priv/BannerRemates.jpg" width="100%" />
			</div>
		</div> -->
		<!-- <div class="posicion-menu-remates p-1"> -->
		<!-- Encabezado de ubicación (Breadcum)-->
		<div class="d-none d-md-block d-lg-block d-xl-block">
			<div class="row d-flex align-items-center">
				<div class="col-12 col-sm-7 pl-0">
					<nav aria-label="breadcrumb ">
						<ol class="breadcrumb pl-0">
							<li class="breadcrumb-item">Captura de pedidos</li>
							<li class="breadcrumb-item">Remates</li>
						</ol>
					</nav>
				</div>
			</div>
		</div>
		<!-- Encabezado -->
		<div class="row d-xs-block d-sm-block d-md-none">
			<div class="col-12 p-0">
				<nav aria-label="breadcrumb ">
					<ol class="breadcrumb pl-0">
						<li class="breadcrumb-item">Captura de pedidos</li>
						<li class="breadcrumb-item">Remates</li>
					</ol>
				</nav>
			</div>			
		</div>
		<div class="row" ref="ancla">
			<div class="col-12 p-1">
				<img alt="image slot" src="@/assets/img-priv/BannerRemates.jpg" width="100%" />
			</div>
		</div>
		<div class="posicion-menu-remates p-1">
			<div class="row bg-white p-1">
				<div class="col-12">
					<div class="d-none d-md-block d-lg-block d-xl-block">
						<div class="row bg-white">
							<div class="col-1 d-block d-md-none d-flex p-0">
								<i class="icon-trazado-1107 align-self-center ml-auto" style="font-size:1.1em;"></i>
							</div>
							<div class="col-11 col-md-3 p-md-0 d-md-flex align-items-center">
								<i
									class="d-none d-md-block icon-trazado-1107 align-self-center ml-auto mr-1"
									style="font-size:1.1em;"
								></i>
								<select
									@change="ordenar"
									class="form-control form-control-sm input-select"
									v-model="parametros.orden"
								>
									<option value="0" hidden>Orden</option>
									<option value="1">Alfabético</option>
									<option value="2">Fórmula</option>
									<option value="3">Precio Ascendente</option>
									<option value="4">Precio Descendente</option>
								</select>
							</div>
							<div class="col-1 d-block d-md-none d-flex p-0 align-items-centerr">
								<i class="icon-trazado-1108 ml-auto" style="font-size:1.1em;"></i>
							</div>
							<div class="col-11 col-md-4 d-md-flex align-items-center">
								<i class="d-none d-md-block icon-trazado-1108 ml-auto mr-1" style="font-size:1.1em;"></i>
								<select
									@change="filtrarFormaFarmaceuticas"
									class="form-control form-control-sm input-select"
									v-model="parametros.codClasificacion"
								>
									<option value="0">Clasificacion</option>
									<option
										:key="index"
										:value="c.codClasificacion"
										v-for="(c, index) in clasificacionesFiltradas"
									>{{ c.descripcion }}</option>
								</select>
							</div>
							<div class="col-11 col-md-4 d-md-flex align-items-center">
							<!-- <div class="col-11 col-md-4 offset-1 offset-md-0"> -->
								<select
									@change="cargaArticulos"
									class="form-control form-control-sm input-select"
									v-model="parametros.codFormaFarmaceutica"
								>
									<option value="0">Forma farmacéutica</option>
									<option
										:key="index"
										:value="f.codFormaFarmaceutica"
										v-for="(f, index) in formasFarmaceuticasFiltradas"
									>{{ f.descripcion }}</option>
								</select>
							</div>
							<div class="col-12 col-md-1 d-md-flex align-items-center justify-content-end d-none">
								<a
									@click="vistaTarjetas(true)"
									class="type-list text-decoration-none"
									href="#"
									v-bind:class="{active: !modoGrid}"
									v-show="!modoGrid"
								>
									<i class="icon-grupo-4354 filtro-fuente"></i>
									<span class="filtro-fuente">Galería</span>
								</a>
								<a
									@click="vistaTarjetas(false)"
									class="type-list text-decoration-none"
									href="#"
									v-bind:class="{active: modoGrid}"
									v-show="modoGrid"
								>
									<i class="icon-grupo-4356 filtro-fuente"></i>
									<span class="filtro-fuente">Listado</span>
								</a>
							</div>
						</div>									
					</div>
					<!-- Modo móvil -->
					<div class="d-xs-block d-sm-block d-md-none">
						<div class="row bg-white">
							<div class="row m-1">
								<div class="col-12 col-md-3 p-0 px-1">
									<div class="d-flex align-items-center">
										<div class="pr-1">
											<i class="icon-trazado-1107 filtro-fuente"></i>
										</div>
										<div class="flex-grow-1">
											<select
												@change="ordenar"
												class="form-control form-control-sm input-select"
												v-model="parametros.orden"
											>
												<option value="0" hidden>Orden</option>
												<option value="1">Alfabético</option>
												<option value="2">Fórmula</option>
												<option value="3">Precio Ascendente</option>
												<option value="4">Precio Descendente</option>
											</select>
										</div>
									</div>
								</div>
								<div class="col-6 col-md-3 offset-md-1 p-0 pt-2 pt-md-0 pl-1 pl-md-0">
									<div class="d-flex align-items-center">
										<div class="pr-1">
											<i class="icon-trazado-1108 filtro-fuente"></i>
										</div>
										<div class="flex-grow-1">
											<select
												@change="filtrarFormaFarmaceuticas"
												class="form-control form-control-sm input-select"
												v-model="parametros.codClasificacion"
											>
												<option value="0">Clasificacion</option>
												<option
													:key="index"
													:value="c.codClasificacion"
													v-for="(c, index) in clasificacionesFiltradas"
												>{{ c.descripcion }}</option>
											</select>
										</div>
									</div>
								</div>
								<div class="col-6 col-md-3 p-0 pt-2 pt-md-0 px-1 pl-3">
									<select
										@change="cargaArticulos"
										class="form-control form-control-sm input-select"
										v-model="parametros.codFormaFarmaceutica"
									>
										<option value="0">Forma farmacéutica</option>
										<option
											:key="index"
											:value="f.codFormaFarmaceutica"
											v-for="(f, index) in formasFarmaceuticasFiltradas"
										>{{ f.descripcion }}</option>
									</select>
								</div>
								<div class="d-none d-md-block col-md-2 p-0 pr-3 pt-1 text-right">
									<a
										@click="vistaTarjetas(true)"
										class="type-list text-decoration-none"
										href="#"
										v-bind:class="{active: !modoGrid}"
										v-show="!modoGrid"
									>
										<i class="icon-grupo-4354 filtro-fuente"></i>
										<span class="filtro-fuente">Galería</span>
									</a>
									<a
										@click="vistaTarjetas(false)"
										class="type-list text-decoration-none"
										href="#"
										v-bind:class="{active: modoGrid}"
										v-show="modoGrid"
									>
										<i class="icon-grupo-4356 filtro-fuente"></i>
										<span class="filtro-fuente">Listado</span>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- tarjetas de productos -->
		<div>
			<div
				:class="[modoGrid ? '' : 'row']"
				class="grid mt-2 d-none d-md-block"
				horizontal-order="true"
				item-selector=".grid-item"
				transition-duration="0.3s"
				v-masonry
			>
				<div
					:class="[modoGrid ? '' : 'col-12 col-xl-6 p-0']"
					:key="index"
					class="grid-item"
					v-for="(item, index) in resultadosMostrar"
					v-masonry-tile
				>
					<pm-card-producto
						:item="item"
						:key="index"
						:modoTarjeta="modoGrid"						
						@agregarCantidad="agregarCarritoTarjeta"						
						@mostrarDetalle="detalleProducto"
						:class="{'ml-xl-1': modoGrid ? true : index%2 != 0, 'mr-xl-1':  modoGrid ? true : index%2 == 0}"
						class="my-1"
					></pm-card-producto>
				</div>
			</div>
		</div>
		<div class="d-md-none d-flex flex-wrap justify-content-center">
			<div :key="index" v-for="(item, index) in resultadosMostrar">
				<pm-card-producto
					:item="item"
					:key="index"
					:modoTarjeta="true"
					@agregarCantidad="agregarCarritoTarjeta"
					@mostrarDetalle="detalleProducto"
					class="mx-2 my-1"
				></pm-card-producto>
			</div>
		</div>

		<div class="row">
			<div class="col-12 pt-3 d-flex justify-content-center">
				<ul class="pagination">
					<li class="page-item " v-show="current_page > 1">
						<a @click="navegar(1)" class="page-link" role="button">«</a>
					</li>
					<li v-show="current_page > 1" class="page-item">
						<a
							@click="navegar(current_page-1)"
							class="page-link text-decoration-none d-none d-md-block"
							role="button"
						>Anterior</a>
					</li>
					<li :class="{active: current_page == pag}" :key="pag" class="page-item" v-for="pag in paginas">
						<a @click="navegar(pag)" class="page-link">{{pag}}</a>
					</li>
					<li class="page-item" v-show="current_page < numPages()">
						<a 	@click="navegar(current_page+1)" 
							class="page-link d-none d-md-block" 
							role="button">Siguiente</a>
					</li>
					<li class="page-item" v-show="current_page < numPages()">
						<a @click="navegar(numPages())" class="page-link" role="button">»</a>
					</li>
				</ul>
			</div>
		</div>

		<!-- <div class="row col-12 justify-content-center mt-2 mb-2">
			<nav aria-label="Page navigation">
				<ul class="pagination justify-content-center">
					<li class="page-item" v-show="current_page > 1">
						<a @click="navegar(1)" class="page-link" role="button">«</a>
					</li>
					<button @click="prevPage" v-show="current_page > 1" class="page-link fuentePaginador">‹ Anterior</button>
					
					<li :class="{active: current_page == pag}" :key="pag" class="page-item" v-for="pag in paginas">
						<a @click="navegar(pag)" class="page-link">{{pag}}</a>
					</li>

					<button @click="nextPage" v-show="current_page < numPages()" class="page-link fuentePaginador ml-2">Siguiente ›</button>
					
					<li class="page-item" v-show="current_page < numPages()">
						<a @click="navegar(numPages())" class="page-link" role="button">»</a>
					</li>
				</ul>
			</nav>
		</div> -->
	</div>
</template>

<script>
	import PmCardProducto from "@/components/clientes/CardProducto"
	import servicioRemates from "@/services/servicio-remates"
	import servicio from "@/services/servicio-detalle-producto"

	export default {
		data() {
			return {
				modoGrid: false,
				clasificaciones: [],
				clasificacionesFiltradas: [],
				formasFarmaceuticasFiltradas: [],
				formasFarmaceuticas: [],
				totalPaginas: 0,
				resultados: [],
				resultadosFiltrados: [],
				resultadosMostrar: [],
				parametros: {
					orden: 0,
					codClasificacion: 0,
					codFormaFarmaceutica: 0
				},
				current_page: 1,
				records_per_page: 10,
				inicio: 0,
				fin: 0,
				paginas: [],
				UUIDAcceso: '',
				//mostrarModal: false,
			}
		},
		components: {
			PmCardProducto
			//TarjetaProducto
		},
		mounted() {
			this.buscar()
			this.carritoConsultarCantidad()
			this.obtenerNotificaciones()
			this.vistaTarjetas(localStorage.getItem('modoGrid') == 'true' ? true : false)
		},
		methods: {
			vistaTarjetas(valor) {
				this.modoGrid = valor
				localStorage.setItem('modoGrid', valor)
				this.$nextTick(() => {
					if (typeof this.$redrawVueMasonry === "function") {
						this.$redrawVueMasonry()
					}
				})
			},
			async agregarCarritoTarjeta(item) {
				if(item.tipoControl == 1 && item.cantidad > 0){
					this.$msg.info( 'Producto refrigerado sin derecho a devolución.')
				} else if(item.precioRemate > 0 && item.cantidad > 0 && item.sinDerechoDevolucion){
					this.$msg.info( 'Producto de remate sin derecho a devolución.')
				} else if (item.cantidad > 0 && item.sinDerechoDevolucion){
					this.$msg.info( 'Producto sin derecho a devolución.')
				}
				
				let token = ''
				if(window.localStorage.tokenDifarmer)
				{
					let lstoken = JSON.parse(window.localStorage.tokenDifarmer)
					token = lstoken.token;
				}

				await this.validarClickPublicidad(item.codArticulo, token)

				this.carritoModificarCantidad(item.codArticulo, item.cantidad, this.UUIDAcceso)
				// this.mostrarModal = true;
				// this.sleep(2000).then(() => {
				// 	this.mostrarModal = false;
				// });
			},
			async validarClickPublicidad(codArticulo, token){
				let r = await servicio.validarClickPublicidad({"idProducto":codArticulo, "accessToken":token} )
				if (r.data){
					this.UUIDAcceso = r.data[0]
				}
			},
			sleep(time) {
				return new Promise(resolve => setTimeout(resolve, time))
			},
			detalleProducto(codArticulo) {
				this.$router.push({ path: `/clientes/detalle-producto/${codArticulo}` })
			},
			ordenar() {
				//Alfabético
				if (this.parametros.orden == 0 || this.parametros.orden == 1) {
					this.resultados.sort((a, b) => {
						return a.descripcion > b.descripcion ? 1 : -1
					})
				}
				//Fórmula
				else if (this.parametros.orden == 2) {
					this.resultados.sort((a, b) => {
						return a.formula > b.formula ? 1 : -1
					})
				}
				//Precio Ascendente
				else if (this.parametros.orden == 3) {
					this.resultados.sort((a, b) => {
						return a.precioNeto > b.precioNeto ? 1 : -1
					})
				}
				//Precio Descendente
				else if (this.parametros.orden == 4) {
					this.resultados.sort((a, b) => {
						return a.precioNeto < b.precioNeto ? 1 : -1
					})
				}
				this.current_page = 1
				this.records_per_page = 10
				this.inicio = 0
				this.fin = 0
				this.resultadosFiltrados = this.resultados
				this.parametros.codClasificacion = 0
				this.parametros.codFormaFarmaceutica = 0
				this.changePage()
				this.filtrarClasificaciones()
			},
			navegar(pagina){
				this.changePage()
				this.current_page = pagina
				this.$nextTick(()=>{
					this.scrollMeTo('ancla')
				})
			},			
			changePage() {
				this.$nextTick(() => {
					this.inicio =
						this.current_page * this.records_per_page - this.records_per_page
					this.fin = this.current_page * this.records_per_page
					this.resultadosMostrar = this.resultadosFiltrados.slice(
						this.inicio,
						this.fin
					)

					this.$nextTick(() => {
						if (typeof this.$redrawVueMasonry === "function") {
							this.$redrawVueMasonry()
						}
					})

					this.paginadorBotones()
				})
			},
			paginadorBotones(){
				
				if (this.current_page == null || this.numPages() == null) return []

				let res = []
				const max = 5
				let aux = Math.floor(max / 2)

				let inicioPaginado = this.current_page - aux > 0 ? this.current_page - aux : 1

				let finPaginado = this.current_page + aux > this.numPages() ? this.numPages() : this.current_page + aux

				for (let i = inicioPaginado; i <= finPaginado; i++) {
					res.push(i)
				}

				this.paginas = res
				//console.log('res', this.paginas)
				
			},
			numPages() {
				return Math.ceil(this.resultadosFiltrados.length / this.records_per_page)
			},
			cargaClasificaciones() {
				servicioRemates
					.clasificaciones()
					.then(r => {
						this.clasificaciones = r.data
						this.filtrarClasificaciones()
					})
					.catch(error => {
						this.$loading(false)
						console.log(error)
					})
			},
			filtrarClasificaciones() {
				var distinctCodClasificaciones = this.resultadosFiltrados.map(
					x => x.codClasificacion
				)
				this.clasificacionesFiltradas = this.clasificaciones.filter(key =>
					distinctCodClasificaciones.includes(key.codClasificacion)
				)
			},
			cargaFormaFarmaceuticas() {
				this.formasFarmaceuticas = []
				servicioRemates
					.formasFarmaceuticas(this.parametros.codClasificacion)
					.then(r => {
						this.formasFarmaceuticas = r.data
						this.filtrarFormaFarmaceuticas()
					})
					.catch(error => {
						this.$loading(false)
						console.log(error)
					})
			},
			filtrarFormaFarmaceuticas() {
				this.parametros.codFormaFarmaceutica = 0
				this.cargaArticulos()
				var distinctFormasFarmaceuticas = this.resultadosFiltrados.map(
					x => x.codFormaFarmaceutica
				)
				this.formasFarmaceuticasFiltradas = this.formasFarmaceuticas.filter(key =>
					distinctFormasFarmaceuticas.includes(key.codFormaFarmaceutica)
				)
			},
			cargaArticulos() {
				this.current_page = 1
				this.records_per_page = 10
				this.inicio = 0
				this.fin = 0
				if (
					this.parametros.codClasificacion > 0 &&
					this.parametros.codFormaFarmaceutica > 0
				) {
					this.resultadosFiltrados = this.resultados.filter(
						obj =>
							obj.codClasificacion == this.parametros.codClasificacion &&
							obj.codFormaFarmaceutica == this.parametros.codFormaFarmaceutica
					)
				} else if (
					this.parametros.codClasificacion == 0 &&
					this.parametros.codFormaFarmaceutica > 0
				) {
					this.resultadosFiltrados = this.resultados.filter(
						obj =>
							obj.codFormaFarmaceutica == this.parametros.codFormaFarmaceutica
					)
				} else if (this.parametros.codClasificacion > 0) {
					this.resultadosFiltrados = this.resultados.filter(
						obj => obj.codClasificacion == this.parametros.codClasificacion
					)
				} else {
					this.resultadosFiltrados = this.resultados
				}

				this.changePage()
			},
			buscar() {
				this.$loading(true)
				servicioRemates
					.remates()
					.then(r => {
						if (!r.value) {
							this.$loading(false)
							return
						}
						this.resultados = r.data
						this.resultadosFiltrados = this.resultados
						this.rematesConsultarCantidad()
						this.cargaClasificaciones()
						this.cargaFormaFarmaceuticas()
						this.changePage()
						this.$loading(false)
					})
					.catch(error => {
						this.$loading(false)
						console.log(error)
					})
			}
		}
	}
</script>

<style scoped>
	.posicion-menu-remates{
		position: sticky;
		top: 60px;
		z-index: 100;
		border-radius: 10px;
	}
	.Titulo {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
		font-weight: bold;
	}
	.fuentePaginador {
		font-family: "Open Sans";
		font-size: 14px;
		color: #0a2157;
	}
	.breadcrumb-item {
		font-weight: 700;
		color: var(--color-font-breadcum);
	}
	.filtro-fondo {
		background-color: #ffffff;
	}
	.filtro-fuente {
		color: var(--bg-menu-blue);
	}
	.input-select {
		border-color: var(--bg-menu-blue);
		color: var(--bg-menu-blue);
	}
	.type-list {
		color: var(--bg-menu-blue);
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		/* Encabezado */
		.breadcrumb-item {
			font-size: 16px;
		}
		/* Filtro */
		.filtro-fuente {
			font-size: 12px;
		}
		.input-select {
			font-size: 12px;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		/* Encabezado */
		.breadcrumb-item {
			font-size: 16px;
		}
		/* Filtro */
		.filtro-fuente {
			font-size: 12px;
		}
		.input-select {
			font-size: 12px;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		/* Encabezado */
		.breadcrumb-item {
			font-size: 16px;
		}
		/* Filtro */
		.filtro-fuente {
			font-size: 14px;
		}
		.input-select {
			font-size: 12px;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		/* Encabezado */
		.breadcrumb-item {
			font-size: 16px;
		}
		/* Filtro */
		.filtro-fuente {
			font-size: 14px;
		}
		.input-select {
			font-size: 12px;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		/* Encabezado */
		.breadcrumb-item {
			font-size: 16px;
		}
		/* Filtro */
		.filtro-fuente {
			font-size: 14px;
		}
		.input-select {
			font-size: 12px;
		}
	}
</style>